var OCS = OCS || {};
OCS.Interfaces = OCS.Interfaces || {};
OCS.Interfaces.DataTypeAdvisory = {
    is_gridded: function () {
        return false;
    },
    get_data_variable: function (data_var) {
        if (OCS.Utilities.is_string(data_var)) {
            data_var = {'parm': data_var};
        }
        if (!data_var || !data_var.parm) {
            return false;
        }
        var data = this.data();
        var vars = this.get_variables();
        var i = 0;
        var id, feature;
        var features = data.features;
        for (i; i < features.length; i++) {
            feature = features[i];
            if (this.get_id_from_prop(feature.properties) === data_var.parm) {
                return feature;
            }

        }
        return false;
    },
    get_variables: function () {
        var data = this.data();
        var vars = [];
        if (data.features && data.features.length) {
            var features = data.features;
            var i = 0;
            var id;
            for (i; i < features.length; i++) {
                vars.push(this.get_id_from_prop(features[i].properties));
            }
        }

        return vars;
    },
    get_id_from_prop: function (properties) {
        var dateObj = OCS.Functions.get_OCSDateTime();
        return properties.nwso + "." + properties.phenom + "." + properties.significance + "." + dateObj.get_utc_string_with_format(properties.issued_time, dateObj.options.year_format) + "." + properties.etn;
    },
    get_variable_units: function () {

    },
    add_data_variable: function (data_in) {
        var existing_data = this.data().features;
        if (data_in && data_in.type === "Feature") {
            existing_data.combine([data_in]);
        }
        if (data_in && data_in.type === "FeatureCollection" && data_in.features && data_in.features.length) {
            data_in.features.each(function (feature) {
                existing_data.combine([feature]);
            });
        }
    }
};